module.exports = __webpack_public_path__ + "img/time-badge-bronze.d80321da.svg";